import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { appConfig } from '@/app/config/appConfig';
import { GameClearModal } from '@/components/shared/GameClearModal';
import { fetchPreviewLevel } from '@/features/game/api/previewApi';
import DemoFlow from '@/features/game/components/DemoFlow';
import type { DemoLevel } from '@/types/sliding-puzzle';
import { STAGE_THEME_COLORS, type StageId } from '@micro-screens/src';

interface PreviewAppProps {
  token: string;
  levelId: string;
}

export function PreviewApp({ token, levelId }: PreviewAppProps) {
  const { t } = useTranslation();
  const [level, setLevel] = useState<DemoLevel | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [showClearModal, setShowClearModal] = useState(false);
  const fetchedRef = useRef(false);

  const stageNo = appConfig.game.stageNo as StageId;
  const theme = STAGE_THEME_COLORS[stageNo];

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;
    fetchPreviewLevel(levelId, token)
      .then(setLevel)
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : 'Failed to load level');
      });
  }, [levelId, token]);

  if (error) {
    return (
      <div
        className="fixed inset-0 flex items-center justify-center"
        style={{ background: '#1c1b20' }}
      >
        <p className="text-white text-sm">{error}</p>
      </div>
    );
  }

  if (!level) {
    return (
      <div
        className="fixed inset-0 flex items-center justify-center"
        style={{ background: '#1c1b20' }}
      >
        <div className="puzzle-loading__spinner" />
      </div>
    );
  }
//test
  return (
    <>
      <DemoFlow
        key="preview"
        stage={stageNo}
        levels={[level]}
        isPreview
        onComplete={() => { setShowClearModal(true); }}
      />
      {showClearModal && (
        <GameClearModal
          title={t('game.boardCompleted')}
          accentColor={theme.resultAccent}
          eclipseColor={theme.eclipse}
          noCountdown
          onConfirm={() => {}}
        />
      )}
    </>
  );
}
